webpackJsonp([1,2],{

/***/ "+LqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GithubCorner_css__ = __webpack_require__("RRR4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GithubCorner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GithubCorner_css__);
/* harmony export (immutable) */ __webpack_exports__["a"] = GithubCorner;




/**
 * wrapper of Tim Holman's Github Corners
 * https://github.com/tholman/github-corners
 */

GithubCorner.defaultProps = {
  bgColor: '#000',
  mainColor: '#FFF',
  left: false
};

function GithubCorner(props) {
  return (
    // Do not allow styling from outside
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { className: __WEBPACK_IMPORTED_MODULE_2__GithubCorner_css___default.a.githubCorner, href: props.repository },
      props.left ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', width: '80', height: '80', viewBox: '0 0 250 250', fill: props.bgColor },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: props.mainColor, d: 'M250 0L135 115h-15l-12 27L0 250V0z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { className: __WEBPACK_IMPORTED_MODULE_2__GithubCorner_css___default.a.octoArm, d: 'M122 109c15-9 9-19 9-19-3-7-2-11-2-11 1-7-3-2-3-2-4 5-2 11-2 11 3 10-5 15-9 16' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { className: __WEBPACK_IMPORTED_MODULE_2__GithubCorner_css___default.a.octoBody, d: 'M135 115s-4 2-5 0l-14-14c-3-2-6-3-8-3 8-11 15-24-2-41-5-5-10-7-16-7-1-2-3-7-12-11 0 0-5 3-7 16-4 2-8 5-12 9s-7 8-9 12c-14 4-17 9-17 9 4 8 9 11 11 11 0 6 2 11 7 16 16 16 30 10 41 2 0 3 1 7 5 11l12 11c1 2-1 6-1 6z' })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', width: '80', height: '80', viewBox: '0 0 250 250', fill: props.bgColor },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { fill: props.mainColor, d: 'M0 0l115 115h15l12 27 108 108V0z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { className: __WEBPACK_IMPORTED_MODULE_2__GithubCorner_css___default.a.octoArm, d: 'M128 109c-15-9-9-19-9-19 3-7 2-11 2-11-1-7 3-2 3-2 4 5 2 11 2 11-3 10 5 15 9 16' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { className: __WEBPACK_IMPORTED_MODULE_2__GithubCorner_css___default.a.octoBody, d: 'M115 115s4 2 5 0l14-14c3-2 6-3 8-3-8-11-15-24 2-41 5-5 10-7 16-7 1-2 3-7 12-11 0 0 5 3 7 16 4 2 8 5 12 9s7 8 9 12c14 3 17 7 17 7-4 8-9 11-11 11 0 6-2 11-7 16-16 16-30 10-41 2 0 3-1 7-5 11l-12 11c-1 1 1 5 1 5z' })
      )
    )
  );
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "3No1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_utils_getRandomArray__ = __webpack_require__("vz7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_utils_getNewObservable__ = __webpack_require__("iHuC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__ = __webpack_require__("FN8c");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handlePadClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleStrictClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleResetClick; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TOGGLE_STRICT = 'TOGGLE_STRICT';
var ADD_PAD = 'ADD_PAD';
var REDO_LEVEL = 'REDO_LEVEL';
var RESET_GAME = 'RESET_GAME';
var INCREMENT_LEVEL = 'INCREMENT_LEVEL';

var addPad = function addPad(color) {
  return { type: ADD_PAD, color: color };
};
var toggleStrict = function toggleStrict() {
  return { type: TOGGLE_STRICT };
};
var redoLevel = function redoLevel() {
  return { type: REDO_LEVEL };
};
var resetGame = function resetGame() {
  return { type: RESET_GAME };
};
var incrementLevel = function incrementLevel() {
  return { type: INCREMENT_LEVEL };
};

var initialState = function initialState() {
  var sequence = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_src_utils_getRandomArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["b" /* COLORS */], __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["d" /* MAX_LEVEL */]);
  var observable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_utils_getNewObservable__["a" /* default */])(sequence, 1, __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["e" /* SEQUENCE_SPEED */]);
  return {
    sequence: sequence,
    padsPlayed: [],
    currentLevel: 1,
    strictMode: false,
    observable: observable
  };
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments[1];

  switch (action.type) {
    case 'ADD_PAD':
      return _extends({}, state, {
        padsPlayed: [].concat(state.padsPlayed, [action.color])
      });
    case 'TOGGLE_STRICT':
      return _extends({}, state, {
        strictMode: !state.strictMode
      });
    case 'REDO_LEVEL':
      return _extends({}, state, {
        padsPlayed: [],
        observable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_utils_getNewObservable__["a" /* default */])(state.sequence, state.currentLevel, __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["e" /* SEQUENCE_SPEED */])
      });
    case 'RESET_GAME':
      return _extends({}, state, {
        sequence: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_src_utils_getRandomArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["b" /* COLORS */], __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["d" /* MAX_LEVEL */]),
        padsPlayed: [],
        currentLevel: 1,
        observable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_utils_getNewObservable__["a" /* default */])(state.sequence, state.currentLevel, __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["e" /* SEQUENCE_SPEED */])
      });
    case 'INCREMENT_LEVEL':
      return _extends({}, state, {
        padsPlayed: [],
        currentLevel: state.currentLevel + 1,
        observable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_utils_getNewObservable__["a" /* default */])(state.sequence, state.currentLevel + 1, __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["e" /* SEQUENCE_SPEED */])
      });
    default:
      return state;
  }
};

var handlePadClick = function handlePadClick(color) {
  return function (dispatch, getState) {
    var _getState = getState(),
        sequence = _getState.sequence,
        padsPlayed = _getState.padsPlayed,
        currentLevel = _getState.currentLevel,
        strictMode = _getState.strictMode;

    var isWrongAnswer = color !== sequence[padsPlayed.length];
    var hasLevelEnded = padsPlayed.length + 1 >= currentLevel;
    var hasGameEnded = currentLevel >= __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["d" /* MAX_LEVEL */];

    if (isWrongAnswer) {
      if (strictMode) {
        return dispatch(resetGame());
      }
      return dispatch(redoLevel());
    }
    if (hasLevelEnded) {
      if (hasGameEnded) {
        return dispatch(resetGame());
      }
      return dispatch(incrementLevel());
    }
    dispatch(addPad(color));
  };
};

var handleStrictClick = function handleStrictClick() {
  return toggleStrict();
};
var handleResetClick = function handleResetClick() {
  return resetGame();
};
/* harmony default export */ __webpack_exports__["a"] = reducer;

/***/ }),

/***/ "6uOm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"screen":"screen--RtemO screen--27rYG"};

/***/ }),

/***/ "9mbo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_css__ = __webpack_require__("VwrH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__ = __webpack_require__("FN8c");
/* harmony export (immutable) */ __webpack_exports__["a"] = Footer;





function Footer() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1__Footer_css___default.a.footer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        href: __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["a" /* REPOSITORY */],
        className: __WEBPACK_IMPORTED_MODULE_1__Footer_css___default.a.text
      },
      'made with \u2665 by Anthony'
    )
  );
}

/***/ }),

/***/ "AuFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Board_css__ = __webpack_require__("fxVb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Board_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Board_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__ = __webpack_require__("FN8c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_Console_Console__ = __webpack_require__("LPwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_Pad_Pad__ = __webpack_require__("qMWN");
/* harmony export (immutable) */ __webpack_exports__["a"] = Board;








function Board() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1__Board_css___default.a.board },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_Console_Console__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["b" /* COLORS */].map(function (color) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_Pad_Pad__["a" /* default */], { color: color, key: color });
    })
  );
}

/***/ }),

/***/ "BdOF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"console":"console--22eyt","title":"title--3LZl8","sup":"sup--3GAN7","screenContainer":"screenContainer--GFoVt","strictContainer":"strictContainer--QcPl4","resetContainer":"resetContainer--Gq2QE","screen":"screen--27rYG","strictButton":"strictButton--1SXNw","resetButton":"resetButton--1yv7L","strictButtonOn":"strictButtonOn--4cOhE strictButton--1SXNw","label":"label--2zNMC"};

/***/ }),

/***/ "CRBD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"green":"green--1I0gO","red":"red--22Ncr","blue":"blue--2WhHm","yellow":"yellow--1Ctpk"};

/***/ }),

/***/ "FN8c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEQUENCE_SPEED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAX_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ANIMATION_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REPOSITORY; });
var SEQUENCE_SPEED = 1000;
var COLORS = ['green', 'red', 'blue', 'yellow'];
var MAX_LEVEL = 10;
var ANIMATION_DURATION = 500;
var REPOSITORY = 'https://github.com/anthony2025/react-simon-game';

/***/ }),

/***/ "LPwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Console_css__ = __webpack_require__("BdOF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Console_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Console_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_redux__ = __webpack_require__("3No1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_EightBitScreen_EightBitScreen__ = __webpack_require__("fnN1");









var mapStateToProps = function mapStateToProps(state) {
  return {
    strictMode: state.strictMode
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onStrictClick: function onStrictClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_utils_redux__["c" /* handleStrictClick */])());
    },
    onResetClick: function onResetClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_src_utils_redux__["d" /* handleResetClick */])());
    }
  };
};

function Console(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.console },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.title },
      'Simon',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'sup',
        { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.sup },
        '\xAE'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.screenContainer },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_EightBitScreen_EightBitScreen__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.screen }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.label },
        'LEVEL'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.strictContainer },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
        className: props.strictMode ? __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.strictButtonOn : __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.strictButton,
        onClick: props.onStrictClick
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.label },
        'STRICT'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.resetContainer },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
        className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.resetButton,
        onClick: props.onResetClick
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__Console_css___default.a.label },
        'RESET'
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Console);

/***/ }),

/***/ "RRR4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"githubCorner":"githubCorner--2_GDu","octoArm":"octoArm--2sxD7","octocat-wave":"octocat-wave--38DtJ"};

/***/ }),

/***/ "RrqR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"app":"app--2Ya5b"};

/***/ }),

/***/ "UL3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightenAnimation = function lightenAnimation(element, duration) {
  var keyframes = [{ filter: 'brightness(1)' }, { filter: 'brightness(2.5)' }];
  var options = {
    duration: duration,
    easing: 'cubic-bezier(0.1, 0.7, 1.0, 0.1)'
  };
  element.animate(keyframes, options);
};

/* harmony default export */ __webpack_exports__["a"] = lightenAnimation;

/***/ }),

/***/ "VwrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer--3QL6W","text":"text--mdphH"};

/***/ }),

/***/ "cilB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fn3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__("RrqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__ = __webpack_require__("FN8c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_GithubCorner_GithubCorner__ = __webpack_require__("+LqF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_Board_Board__ = __webpack_require__("AuFu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_Footer_Footer__ = __webpack_require__("9mbo");
/* harmony export (immutable) */ __webpack_exports__["a"] = App;









function App() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1__App_css___default.a.app },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_GithubCorner_GithubCorner__["a" /* default */], {
      repository: __WEBPACK_IMPORTED_MODULE_2_src_utils_constants__["a" /* REPOSITORY */],
      bgColor: 'white',
      mainColor: '#9F0F17'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_Board_Board__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_Footer_Footer__["a" /* default */], null)
  );
}

/***/ }),

/***/ "fnN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EightBitScreen_css__ = __webpack_require__("6uOm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EightBitScreen_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EightBitScreen_css__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EightBitScreen; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var EightBitScreen = function (_Component) {
  _inherits(EightBitScreen, _Component);

  function EightBitScreen() {
    var _temp, _this, _ret;

    _classCallCheck(this, EightBitScreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      value: 10
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  EightBitScreen.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__EightBitScreen_css___default.a.screen },
      this.state.value
    );
  };

  return EightBitScreen;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);



/***/ }),

/***/ "fxVb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"board":"board--2R5J0"};

/***/ }),

/***/ "iHuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__("Gvdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);


var getNewObservable = function getNewObservable(source, take, speed) {
  return __WEBPACK_IMPORTED_MODULE_0_rxjs___default.a.Observable.interval(speed).take(take).map(function (i) {
    return source[i];
  });
};

/* harmony default export */ __webpack_exports__["a"] = getNewObservable;

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__("cilB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension__ = __webpack_require__("gFN5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_thunk__ = __webpack_require__("4ufr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_redux_js__ = __webpack_require__("3No1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_App_App__ = __webpack_require__("fn3x");












var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_6_src_utils_redux_js__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_devtools_extension__["composeWithDevTools"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_5_redux_thunk___default.a)));

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* Provider */],
  { store: store },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_src_App_App__["a" /* default */], null)
), document.querySelector('#app'));

/***/ }),

/***/ "qMWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pad_css__ = __webpack_require__("CRBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pad_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Pad_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_utils_redux__ = __webpack_require__("3No1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_utils_constants__ = __webpack_require__("FN8c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_utils_lightenAnimation__ = __webpack_require__("UL3A");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var mapStateToProps = function mapStateToProps(state) {
  return {
    observable: state.observable
  };
};
var mapDispatchToProps = {
  onPadClick: __WEBPACK_IMPORTED_MODULE_4_src_utils_redux__["b" /* handlePadClick */]
};

var Pad = function (_Component) {
  _inherits(Pad, _Component);

  function Pad(props) {
    _classCallCheck(this, Pad);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.light = function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_utils_lightenAnimation__["a" /* default */])(_this.pad, __WEBPACK_IMPORTED_MODULE_5_src_utils_constants__["c" /* ANIMATION_DURATION */]);
    };

    _this.sound = function () {
      return _this.audioObject.play();
    };

    _this.animate = function () {
      _this.light();_this.sound();
    };

    _this.handlePadClick = function () {
      _this.animate();
      _this.props.onPadClick(_this.props.color);
    };

    _this.refreshObservable = function () {
      _this.props.observable.subscribe(function (color) {
        if (color === _this.props.color) _this.light();
      });
    };

    _this.audioObject = new Audio('audio/sound-' + _this.props.color + '.mp3');
    _this.pad; // reference to the DOM element
    return _this;
  } // light + sound

  Pad.prototype.componentDidMount = function componentDidMount() {
    this.refreshObservable();
  };

  Pad.prototype.componentDidUpdate = function componentDidUpdate() {
    this.refreshObservable();
  };

  Pad.prototype.render = function render() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', {
      className: __WEBPACK_IMPORTED_MODULE_2__Pad_css___default.a[this.props.color],
      ref: function ref(pad) {
        return _this2.pad = pad;
      },
      onClick: this.handlePadClick
    });
  };

  return Pad;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Pad);

/***/ }),

/***/ "vz7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getRandomInteger = function getRandomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

var getRandomArray = function getRandomArray(source, length) {
  return Array(length).fill().map(function () {
    return source[getRandomInteger(0, source.length - 1)];
  });
};

/* harmony default export */ __webpack_exports__["a"] = getRandomArray;

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.ce3f00fe.js